var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.0374 0 0 4.0374 0 9V12.7287C0 13.6503 0.8073 14.4 1.8 14.4H2.7C2.93869 14.4 3.16761 14.3052 3.3364 14.1364C3.50518 13.9676 3.6 13.7387 3.6 13.5V8.8713C3.6 8.63261 3.50518 8.40369 3.3364 8.2349C3.16761 8.06612 2.93869 7.9713 2.7 7.9713H1.8828C2.3832 4.4883 5.3802 1.8 9 1.8C12.6198 1.8 15.6168 4.4883 16.1172 7.9713H15.3C15.0613 7.9713 14.8324 8.06612 14.6636 8.2349C14.4948 8.40369 14.4 8.63261 14.4 8.8713V14.4C14.4 15.3927 13.5927 16.2 12.6 16.2H10.8V15.3H7.2V18H12.6C14.5854 18 16.2 16.3854 16.2 14.4C17.1927 14.4 18 13.6503 18 12.7287V9C18 4.0374 13.9626 0 9 0Z",
    fill: "#B2B2B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector6);
export default __webpack_public_path__ + "static/media/Vector6.c9de92e9e8fbfdeed85f44065459e8aa.svg";
export { ForwardRef as ReactComponent };